module.exports = __webpack_public_path__ + "img/menu-icon-faq.de3558cf.svg";